import { render, staticRenderFns } from "./RepairDeleteConfirm.vue?vue&type=template&id=156a5f67"
import script from "./RepairDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./RepairDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports